function TagList({
    className,
    resultTag
}) {
    return (<ul className={'result-tag ' + className}>
        {resultTag.map((x, i) => <li key={i}>#{x}</li>)}
    </ul>);
}

export default TagList;